export default function BackgroundTexture() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 z-[90]">
      {/* Dot grid */}
      <div
        className="absolute inset-0 opacity-[0.55] mix-blend-screen"
        style={{
          backgroundImage:
            'radial-gradient(circle, rgba(248,248,246,0.09) 1px, transparent 1.5px)',
          backgroundSize: '34px 34px',
        }}
      />

      {/* Soft gold glow accents */}
      <div
        className="absolute -left-40 -top-40 h-[42rem] w-[42rem] rounded-full mix-blend-screen"
        style={{
          background:
            'radial-gradient(circle, rgba(201,169,110,0.07), transparent 70%)',
        }}
      />
      <div
        className="absolute -right-52 top-1/3 h-[40rem] w-[40rem] rounded-full mix-blend-screen"
        style={{
          background:
            'radial-gradient(circle, rgba(201,169,110,0.05), transparent 70%)',
        }}
      />
      <div
        className="absolute -bottom-52 -left-32 h-[44rem] w-[44rem] rounded-full mix-blend-screen"
        style={{
          background:
            'radial-gradient(circle, rgba(201,169,110,0.055), transparent 70%)',
        }}
      />
    </div>
  );
}
